<template>
  <div>
      <div v-bind:class="{ 'coder-wrapper': true, 'hasError': this.hasError }">
        <div class="coder-v-line"></div>
        <div class="coder-v-js" v-show="!this.hasError"></div>

        <div class="coder-row">
          <div class="coder-content-box layout-fw">
            <div class="coder-line">Line</div>
            <div class="coder-content">
              <div class="coder-js">JavaScript</div>
              <div class="coder-reason">Explanation</div>
            </div>
          </div>
          <div class="color-line-border layout-fw"></div>
        </div>


        <div v-for="(code, key) in codes" class="coder-row" :class="{
          'error': code.errors,
          'active': code.active
        }">

          <div class="coder-content-box layout-fw">
            <div class="coder-line">{{ key + 1 }}</div>
            <div class="coder-content">
              <div class="coder-js"><input @click="setFocusCursor('script', key)" @focus="setFocusCursor('script', key)" @keyup="(evt) => { keyUP({ evt, code, member: 'script', index: key }); }" v-focus="focusMe('script', key)" v-model="code.script" /></div>
              <div class="coder-reason"><input @click="setFocusCursor('explanation', key)" @focus="setFocusCursor('explanation', key)" @keyup="(evt) => { keyUP({ evt, code, member: 'explanation', index: key }); }" v-focus="focusMe('explanation', key)" v-model="code.explanation" /></div>
            </div>
          </div>

          <div class="coder-content-box layout-fw" v-for="err in code.errors" v-if="code.errors">
            <div class="coder-line"></div>
            <div class="coder-content error-msg">
              {{ err.msg }}
            </div>
          </div>

          <div class="color-line-border layout-fw"></div>
        </div>

        <!--
        <pre>{{ JSON.stringify(example, null, '\t') }}</pre>
        <pre>{{ JSON.stringify(currentFocus, null, '\t') }}</pre>
        <pre>{{ JSON.stringify(codes, null, '\t') }}</pre>


        {/*<div class="coder-row">
          <div class="coder-content-box layout-fw">
            <div class="coder-line">1</div>
            <div class="coder-content">
              <div class="coder-js">var myAge;</div>
              <div class="coder-reason">declare the myAge varaible</div>
            </div>
          </div>
          <div class="color-line-border layout-fw"></div>
        </div>*/}
        -->


        <!--
        {/*<pre>{ JSON.stringify(this.logs, null, '\t') }</pre>
        <pre>{ JSON.stringify(this.codes, null, '\t') }</pre>*/}
        -->

        <!--

         -->
        <div class="coder-console">

          <h1 class="console-title">Console</h1>

          <div v-for="(item, key) in logs" class="console-row" @mouseenter="highlightAtLine(item.line)" @mouseleave="cancelHighLightAtLine(item.line)">
            Line {{ item.line }}:
            <span v-for="(arg, key) in item.args" class="console-arg">{{ JSON.stringify(arg) }} {{ key < (item.length - 1) ? ', ' : '' }}</span>
          </div>

        </div>

      </div><!-- coder-wrapper -->
    </div><!-- wrapper -->
</template>

<script>
var JSHINT = require('jshint/dist/jshint').JSHINT

import { db } from '@/firebase'
import Vue from 'vue'
// import { mapActions } from 'vuex'

Vue.directive('value', {
  componentUpdated: (el, binding) => {
    if (el.value !== binding.value) {
      el.value = binding.value
    }
  }
})

Vue.directive('focus', {
  componentUpdated: (el, binding) => {
    if (binding.value === true) {
      el.focus()
    }
  }
})

export default {
  name: 'coder',
  props: ['example'],
  watch: {
    example () {
      this.refresh()
    }
  },
  data () {
    return {
      currentHighlight: 0,
      currentFocus: {
        script: 0,
        explanation: 0,
        activeColumn: 'script'
      },
      hasError: false,
      logs: [],
      timeout: {
        script: 0,
        explanation: 0
      }
    }
  },
  computed: {
    codes () {
      return this.example.codes
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    cancelHighLightAtLine (line) {
      this.codes[line - 1].active = false
      this.$forceUpdate()
    },
    highlightAtLine (line) {
      this.codes[line - 1].active = true
      this.$forceUpdate()
    },
    addToIndex (idx, obj) {
      var codeLine = this.codes
      codeLine[idx].errors = codeLine[idx].errors || []
      codeLine[idx].errors.push(obj)
      console.table(codeLine[idx].errors)
    },
    break (error) {
      console.log(error)
      this.hasError = true
      var codeLine = this.codes
      this.addToIndex(error.index, error)
      codeLine.forEach((code, index) => {
        if (index === error.index) {
          codeLine[index].status = 'fail'
        } else if (index > error.index) {
          codeLine[index].status = 'error'
        }
      })
      console.table(codeLine)
    },
    saveJSHintError (jsherr) {
      this.hasError = true
      var codeLine = this.codes
      this.addToIndex(jsherr.index, jsherr)

      codeLine[jsherr.index].status = 'fail'
      console.log(codeLine[jsherr.index].errors[0])
    },
    doneCheckSyntax () {
      var codeLine = this.codes
      codeLine.forEach((code, index) => {
        if (typeof code.status === 'undefined') {
          code.status = 'error'
        }
      })
      console.table(codeLine)
    },
    done () {
      var codeLine = this.code
      console.table(codeLine)
    },
    reset () {
      // console.clear()
      this.clearToDom()
      var codeLine = this.codes
      this.hasError = false
      codeLine.forEach((code) => {
        delete code.errors
        delete code.status
      })
    },
    clearToDom () {
      this.logs = []
    },
    logToDom () {
      var args = [].slice.call(arguments)
      var lineAt = args.pop() // get the last argument

      var result = args.reduce(function (accu, item) {
        accu.push(JSON.parse(JSON.stringify(item)))
        return accu
      }, [])
      this.logs.push({
        line: lineAt,
        args: result
      })
    },
    refresh () {
      var codeLine = this.codes
      this.reset()

      var consoleStub = this.consoleStub = {
        // console
        trace: () => {
          console.trace()
        },
        clear: this.clearToDom,
        log: this.logToDom,
        error: () => {
          console.error(...arguments)
        }
      }

      var logger = {
        // logger
        break: this.break,
        done: this.done
      }

      var jshiner = []

      var statementSkipper = 0
      var code = this.execCode = codeLine.reduce((accu, item, key) => {
        let hasConsole = item.script.indexOf('console.') !== -1
        // inject line to console argument
        let output = item.script
        if (hasConsole) {
          output = output.replace(')', `, ${key + 1})`)
        }
        // clean for loop
        let hasForLoop = item.script.indexOf('for') !== -1
        if (hasForLoop) {
          let rand = Math.floor(Math.random() * 100000000) + '_' + Math.floor(Math.random() * 100000000)
          output = `var Loop_Protector_${rand} = 0; ${output}`
          if (output.indexOf('{') !== -1) {
            output = output.replace('{', `{
                if (Loop_Protector_${rand} > 10000) { break; } else { Loop_Protector_${rand}++; }
            `)
          } else {
            output = `throw new Error('wrong for loop')`
          }
        }

        let hasEndStatement = item.script.indexOf(';') !== -1
        if (hasEndStatement && !hasForLoop) {
          let count = output.split('').reduce((accu, item) => {
            if (item === ';') {
              accu++
            }
            return accu
          }, 0)

          let replacer = `; LINE_AT = ${key}; SKIP = ${statementSkipper}; LINE = LINE + ${count};`
          output = output.replace(';', replacer)
        } else {
          statementSkipper = statementSkipper + 1
        }

        output = output + '   //AT_LINE@' + (key + 1)
        jshiner.push(output)
        return accu + `
          ${output}
        `
      }, '')
      console.log(code)
      var allCode = `
        'use strict';
        console.clear();
        var LINE = 0; var SKIP = 0; var LINE_AT = 0;
        var ALL_SKIPPED = ${statementSkipper};
        var BREAK_AT = 0;
        try {
            ${code}
        } catch (error) {
            console.trace('At runner');
            BREAK_AT = LINE + SKIP;

            logger.break({
                index: BREAK_AT,
                msg: error.message
            });
        }
        logger.done();
      `

      try {
        /* eslint-disable no-new-func */
        var env = new Function('window', 'requestAnimationFrame', 'self', 'top', 'console', 'logger', 'alert', 'prompt', 'confirm', 'codeLine', allCode)
        env.call(
          {
            // context
          },
          window,
          function () { console.log('rAF blocked') },
          {
              // self
          },
          {
              // top
          },
          consoleStub,
          logger,
          function () { console.log('alert blocked') },
          function () { console.log('prompt blocked') },
          function () { console.log('confirm blocked') },
          codeLine
        )
      } catch (error) {
        console.trace()
        console.log(error)
        console.error(allCode)

        // codeLine.map((item, key) => {
        //   return item.script
        // })

        JSHINT(jshiner)

        // console.table(JSHINT.errors)

        JSHINT.errors.forEach((eerr) => {
          this.saveJSHintError({
            index: eerr.line - 1,
            msg: eerr.reason
          })
        })
        this.doneCheckSyntax()
      }
    },
    focusMe (member, key) {
      return this.currentFocus.activeColumn === member && this.currentFocus[member] === key
    },
    saveCode () {
      db.ref('examples').child(this.example['.key']).child('codes').set(this.codes)
    },
    shouldSaveCode (member) {
      clearTimeout(this.timeout[member])
      this.timeout[member] = setTimeout(() => {
        this.saveCode()
      }, 500)
    },
    setFocusCursor (member, cursor) {
      this.currentFocus.activeColumn = member
      this.currentFocus[member] = cursor
    },
    setNextFrameFocusCursor (member, cursor) {
      Vue.nextTick(() => {
        this.setFocusCursor(member, cursor)
      }, this)
    },
    keyUP ({ evt, code, member, index }) {
      member === 'script' && this.refresh()

      if (evt.keyCode === 13) {
        evt.preventDefault()

        var leftString = evt.target.value.substring(0, evt.target.selectionStart) || ''
        var rightString = evt.target.value.substring(evt.target.selectionStart) || ''
        var newObj = {
          script: rightString,
          explanation: ''
        }

        this.codes[index][member] = leftString
        this.codes.splice(index + 1, 0, newObj)

        this.setFocusCursor(member, index + 1)
        this.shouldSaveCode(member)
      } else if (evt.keyCode === 40) {
        // 40 = down
        this.setFocusCursor(member, index + 1)
      } else if (evt.keyCode === 38) {
        // 38 = up
        this.setFocusCursor(member, index - 1)
      } else if ((evt.keyCode === 8 || evt.keyCode === 46) && code[member].trim() === '') {
        evt.preventDefault()

        if (this.codes.length > 1 && code['script'].trim() === '' && code['explanation'].trim() === '') {
          this.codes.splice(index, 1)
          this.shouldSaveCode(member)
          this.setFocusCursor(member, index - 1)
        }
      } else {
        this.setFocusCursor(member, index)
        this.shouldSaveCode(member)
      }
    } // key up
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './layout.scss';
$js-height: 50px;


.coder-wrapper{
  font-family: 'Exo 2';
  letter-spacing: 0.15px;

  position: relative;
  padding-bottom: 50vh;
}

.color-line-border{
  height: 1px;
  background-image: linear-gradient(90deg, rgba(hotpink, 0.2), rgba(cyan, 0.2));
}
.coder-row:hover .color-line-border{
  background-image: linear-gradient(90deg, rgba(hotpink, 1.0), rgba(cyan, 1.0));
}
.coder-row.error .color-line-border{
  background-image: linear-gradient(90deg, #FFF100, #FF0024);
}
.coder-row.active{
  background-image: linear-gradient(90deg, hotpink, cyan);
  input {
    background-color:transparent;
    color: white;
  }
}
.coder-row.active .coder-line{
  color: white;
}
.coder-row.error .coder-line{
  color: red;
}
.coder-row.error .error-msg{
  color: red;
}
.coder-row.error.active .error-msg{
  color: yellow;
}
.coder-content-box{
  min-height: $js-height;
}

.coder-content-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.coder-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//=-=-=-==-=-=-=-=-=-==-=-=-==-=-=-=-=-=-

//=-=-=-==-=-=-=-=-=-==-=-=-==-=-=-=-=-=-

$js-height: 40px;
$line-box-width: 70px;
$line-box-padding: 40px;
.coder-line{
  text-align: right;
  width: $line-box-width;
  padding-right: $line-box-padding;
}
.coder-content{
  width: calc(100% - #{ $line-box-padding });
}
.coder-js{
  width: 50%;
  input {
    font-size: 15px;
    border: none;
    width: calc(100% - 35px);
  }
}
.coder-reason{
  width: 50%;
  input {
    font-size: 15px;
    border: none;
    width: calc(100% - 35px);
  }
}

.coder-v-line{
  background-image: linear-gradient(180deg, hotpink, cyan);
  position: absolute;
  top: 0px;
  left: calc(#{ $line-box-width } + #{ $line-box-padding / 3 });
  width: 1px;
  height: 100%;
}

.coder-v-js{
  background-image: linear-gradient(180deg, hotpink, cyan);
  position: absolute;
  top: 0px;
  right: calc( (100% - #{ $line-box-width }) * 0.5 );
  // right: calc( 100% - 50% -  - #{ $line-box-padding / 3 } );
  width: 1px;
  height: 100%;
}


.console-row{
  width: 100%;
  padding: 0px 25px;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: white solid 1px;
}

.console-arg{
  padding: 0px 15px;
}

.coder-console{
  position: fixed;
  bottom: 0px;
  height: 30%;
  transform: translateZ(1px);
  width: calc(100% - 50px);
  max-width: calc(1440px - 50px);
  overflow: scroll;

  background-image: linear-gradient(45deg, hotpink, cyan);
  color: white;
  font-family: 'Exo';
}

.console-title{
  padding: 0px 25px;
}



</style>



// WEBPACK FOOTER //
// Coder.vue?6465ae56